module.exports = __webpack_public_path__ + "img/DE00917.9db3fd39.png";